import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import AddShoppingCartRoundedIcon from "@mui/icons-material/AddShoppingCartRounded";

import { useAuth } from "../../Context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import cafeLogo from "../../Assets/logo.png";

const ClientHeader = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };



  const goToMakeOrder = () => {
    navigate("/clint/make-order");
  };

  const goToMyOrders = () => {
    navigate("/clint/orders/history");
  };

  const goToMenu = () => {
    navigate("/clint/menu");
  };

  const isMenuActive = location.pathname.startsWith("/clint/menu");
  const isOrdersActive = location.pathname.startsWith("/clint/orders");
  const isMakeOrderActive = location.pathname.startsWith("/clint/make-order");

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        background: "rgba(255, 255, 255, 0.85)",
        backdropFilter: "blur(8px)",
        borderBottom: "1px solid",
        borderColor: "divider",
        color: "text.primary",
      }}
    >
      <Toolbar
        sx={{
          minHeight: "72px !important",
          gap: 1.5,
          flexWrap: { xs: "wrap", md: "nowrap" },
          py: { xs: 1, md: 0 },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
          <Box
            component="img"
            src={cafeLogo}
            alt="Nuvvy"
            sx={{
              width: 42,
              height: 42,
              objectFit: "contain",
              borderRadius: 1.5,
              boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
            }}
          />
          <Box>
            <Typography
              variant="h6"
              component="div"
              sx={{ fontWeight: 900, letterSpacing: "0.04em", lineHeight: 1.1 }}
            >
              Nuvvy
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
              Client Area
            </Typography>
          </Box>
        </Box>

        <Box sx={{ flexGrow: 1 }} />

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexWrap: { xs: "wrap", md: "nowrap" },
            width: { xs: "100%", md: "auto" },
            justifyContent: { xs: "space-between", md: "flex-end" },
          }}
        >
          <Button
            variant={isMakeOrderActive ? "contained" : "outlined"}
            color="success"
            startIcon={<AddShoppingCartRoundedIcon />}
            onClick={goToMakeOrder}
            sx={{ fontWeight: 700, borderRadius: 2, px: 1.5 }}
          >
            إنشاء طلب
          </Button>

          <Button
            variant={isMenuActive ? "contained" : "outlined"}
            color={isMenuActive ? "primary" : "inherit"}
            startIcon={<MenuBookRoundedIcon />}
            onClick={goToMenu}
            sx={{ fontWeight: 700, borderRadius: 2, px: 1.5 }}
          >
            المنيو
          </Button>

          <Button
            variant={isOrdersActive ? "contained" : "outlined"}
            color={isOrdersActive ? "primary" : "inherit"}
            startIcon={<ReceiptLongRoundedIcon />}
            onClick={goToMyOrders}
            sx={{ fontWeight: 700, borderRadius: 2, px: 1.5 }}
          >
            طلباتي
          </Button>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.8,
              px: 1,
              py: 0.5,
              borderRadius: 99,
              bgcolor: "action.hover",
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
              {user?.name || "User"}
            </Typography>
            <Avatar sx={{ width: 30, height: 30, bgcolor: "primary.main", fontSize: 14 }}>
              {user?.name?.charAt(0) || "U"}
            </Avatar>
          </Box>

          <IconButton
            onClick={handleLogout}
            aria-label="logout"
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              color: "error.main",
            }}
          >
            <ExitToAppIcon />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default ClientHeader;
